export default __webpack_public_path__ + "static/media/fundingTransfer.a4461f3b.svg";